import React, { ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import { IssueEntity } from 'types/IssueEntity'
import { WarrantName } from '../../../components/entities/WarrantName'
import { FactsTableRow } from '../../components/FactsTable'

export function WarrantsRow({ issue }: { issue: IssueEntity }) {
    if (issue.warrants && issue.warrants.length > 0) {
        const warrantElements: ReactNode[] = []
        issue.warrants.forEach((warrant) => {
            warrantElements.push(
                <Typography key={warrant.id}>
                    <Link to={`/warrants/${warrant.id}`}>
                        <WarrantName warrant={warrant} />
                    </Link>
                    <br />
                </Typography>,
            )
        })
        return <FactsTableRow label='Teckningsoptioner'>{warrantElements}</FactsTableRow>
    } else {
        return (
            <FactsTableRow label='Teckningsoptioner'>
                <i>(Inga)</i>
            </FactsTableRow>
        )
    }
}
